<template>
  <el-table
    v-loading="loading"
    class="mt-xl"
    header-row-class-name="table-header"
    :data="data"
    size="small"
  >
    <el-table-column
      v-for="(c, index) in columns"
      :key="index"
      :prop="c.key"
      :label="c.label"
      :align="c.align"
      :width="c.width"
      :min-width="c.min_width"
    >
      <template slot-scope="scope">
        <span v-if="c.options">
          <el-tag
v-if="!!scope.row[c.key]"
size="mini">{{ c | getTagValue(scope.row) }}</el-tag>
        </span>
        <div v-else-if="c.key === 'form_required'">
          <el-checkbox
v-model="scope.row.form.required"
:disabled="!isEdit || disableCheckbox(scope.row.type)" />
        </div>
        <div v-else-if="c.key === 'show_create_form'">
          <el-checkbox
v-model="scope.row.show.create_form"
:disabled="!isEdit || disableCheckbox(scope.row.type)" />
        </div>
        <div v-else-if="c.key === 'show_column'">
          <el-checkbox
v-model="scope.row.show.column"
:disabled="!isEdit || disableCheckbox(scope.row.type)" />
        </div>
        <div v-else-if="c.key === 'show_fast_filter'">
          <el-checkbox
v-model="scope.row.show.fast_filter"
:disabled="!isEdit || disableCheckbox(scope.row.type)" />
        </div>
        <div v-else-if="c.key === 'show_filter'">
          <el-checkbox
v-model="scope.row.show.filter"
:disabled="!isEdit || disableCheckbox(scope.row.type)" />
        </div>
        <div v-else-if="c.key === 'show_import_export'">
          <el-checkbox
v-model="scope.row.show.import_export"
:disabled="!isEdit || disableCheckbox(scope.row.type)" />
        </div>
        <div v-else-if="c.key === 'column_short'">
          <el-checkbox
v-model="scope.row.column.short"
:disabled="!isEdit || disableCheckbox(scope.row.type)" />
        </div>
        <span v-else>
          {{ scope.row[c.key] }}
        </span>
      </template>
    </el-table-column>
    <el-table-column
label="Thao tác"
width="120"
fixed="right"
align="center">
      <template slot-scope="scope">
        <Buttons
          :item="scope.row"
          :buttons="['edit', 'delete']"
          @edit="(v) => $emit('edit', v)"
          @delete="(v) => $emit('delete', v)"
        />
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import Buttons from "@/components/items/Buttons.vue";
import CONSTANTS from "@/config/constants";

export default {
  name: "CardList",
  components: {
    Buttons,
  },
  props: {
    data: Array,
    groups: Array,
    loading: Boolean,
    isEdit: Boolean
  },
  computed: {
    columns() {
      return [
        {
          label: "STT",
          key: "order",
          width: 50,
        },
        {
          label: "Mã trường",
          key: "key",
          width: 200,
        },
        {
          label: "Tên trường",
          key: "name",
          min_width: 200,
        },
        {
          label: "Loại",
          key: "type",
          options: CONSTANTS.FIELD_TYPES,
          align: "center",
          width: 150,
        },
        {
          label: "Bắt buộc",
          key: "form_required",
          width: 120,
          align: "center",
        },
        {
          label: "Form tạo",
          key: "show_create_form",
          width: 120,
          align: "center",
        },
        {
          label: "Cột",
          key: "show_column",
          width: 120,
          align: "center",
        },
        {
          label: "Tìm nhanh",
          key: "show_fast_filter",
          width: 120,
          align: "center",
        },
        {
          label: "Tìm kiếm",
          key: "show_filter",
          width: 120,
          align: "center",
        },
        {
          label: "Import/Export",
          key: "show_import_export",
          width: 120,
          align: "center",
        },
        {
          label: "Sắp xếp",
          key: "column_short",
          width: 120,
          align: "center",
        },
      ];
    },
  },
  methods: {
    disableCheckbox(type) {
      return [
        CONSTANTS.FIELD_TYPE.HTML,
        CONSTANTS.FIELD_TYPE.MULTIPLE_SELECT,
        CONSTANTS.FIELD_TYPE.FILE_VIDEOS,
        CONSTANTS.FIELD_TYPE.FILE_AUDIOS,
        CONSTANTS.FIELD_TYPE.FILE_OTHERS,
        CONSTANTS.FIELD_TYPE.LINK_3DS,
        CONSTANTS.FIELD_TYPE.LINK_YOUTUBE,
        CONSTANTS.FIELD_TYPE.MULTIPLE_CONNECTION,
      ].includes(type)
    }
  },
};
</script>

<style lang="scss"></style>
